"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    modelValue: {
        type: String,
        default: undefined
    },
    buttons: {
        type: Boolean,
        default: undefined
    },
    clearButton: {
        type: Boolean,
        default: undefined
    },
    columns: {
        type: Number,
        default: undefined
    },
    tileSize: {
        type: [Number, Object],
        default: undefined
    },
    messages: {
        type: Object,
        default: undefined
    },
    palette: {
        type: [String, Array],
        default: undefined
    },
    opacity: {
        type: Boolean,
        default: undefined
    },
    preview: {
        type: Boolean,
        default: undefined
    },
    toolIcon: {
        type: String,
        default: undefined
    },
    value: {
        type: String,
        default: undefined
    },

    // Events
    change: Function,
    select: Function,
    open: Function,
    close: Function
};